import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { BannerData } from "types/models/master/MasterApp";
import ImageIcon from "@mui/icons-material/Image";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

interface TableItemProps {
  data: BannerData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const handleImageClick = () => {
    setImageUrl(data.image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getStatusColor = () => {
    switch (data.active) {
      case true:
        return "#43C888";
      case false:
        return "#F84E4E";
      default:
        return "#E2A72E";
    }
  };

  return (
    <>
      <TableRow key={data.bannerType} className="item-hover">
        <StyledTableCell align="left">
          <OrderActions data={data} />
        </StyledTableCell>

        <StyledTableCell align="left">
          <Box sx={{ color: "black", borderBottom: "none", display: "inline-block" }}>
            {data.bannerType}
          </Box>
        </StyledTableCell>

        <StyledTableCell align="left">{data.title}</StyledTableCell>

        <StyledTableCell align="left">
          <IconButton onClick={handleImageClick}>
            <ImageIcon />
          </IconButton>
        </StyledTableCell>

        <StyledTableCell align="left">{data.index}</StyledTableCell>

        <StyledTableCell align="left">
          <Box
            sx={{
              color: getStatusColor(),
              backgroundColor: getStatusColor() + "44",
              padding: "3px 5px",
              borderRadius: 1,
              fontSize: 14,
              minWidth: 80,
              textAlign: "center",
              display: "inline-block",
            }}
          >
            {data.active ? "Active" : "Inactive"}
          </Box>
        </StyledTableCell>
      </TableRow>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: 4,
            boxShadow: 24,
            maxWidth: "80%",
            maxHeight: "80%",
            overflow: "auto",
          }}
        >
          <img src={imageUrl} alt="banner" style={{ width: "100%", height: "auto" }} />
        </Box>
      </Modal>
    </>
  );
};

export default TableItem;
